export function formatInDate(dateString: string, notHour: boolean = false) {
  if (dateString) {
    const date = new Date(dateString);
    const formatDate = date.toLocaleDateString('pt-BR');
    if (notHour) {
      return formatDate;
    } else {
      const formatTime = date.toLocaleTimeString('pt-BR', {
        hour: '2-digit',
        minute: '2-digit'
      });
      return `${formatDate} - ${formatTime}`;
    }
  }
}
export function formataDate(criadoEm: string | Date) {
  const data1 = new Date(criadoEm ?? "");
  const data2 = new Date();
  const diferencaTempo = Math.abs(data2.getTime() - data1.getTime());
  const diferencaEmMinutos = Math.ceil(diferencaTempo / (1000 * 60));
  const diferencaHora = Math.floor(diferencaTempo / (1000 * 60 * 60));
  const diferencaDia = Math.floor(diferencaTempo / (1000 * 60 * 60 * 24));

  function formataEmMinutos() {
    if (diferencaEmMinutos < 2) {
      return "Agora";
    } else {
      return `${diferencaEmMinutos} minutos`;
    }
  }

  function formataHorasEntre() {
    if (diferencaHora < 2) {
      return `${diferencaHora} hora`;
    } else {
      return `${diferencaHora} horas`;
    }
  }

  function formataDiasEntre() {
    if(diferencaDia < 2){
      return `${diferencaDia} dia`;
    } else {
      return `${diferencaDia} dias`;
    }
  }

  if (diferencaDia >= 1) {
    return { display: formataDiasEntre(), value: diferencaDia * 24 * 60 }; // Retorna em minutos
  }

  if (diferencaHora >= 1) {
    return { display: formataHorasEntre(), value: diferencaHora * 60 }; // Retorna em minutos
  }

  return { display: formataEmMinutos(), value: diferencaEmMinutos };
}


